import React, {useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import MDBox from "../../../components/MDBox";
import MDTypography from "../../../components/MDTypography";
import Fade from "@mui/material/Fade";
import Card from "@mui/material/Card";
import {MuiDataGrid} from "../../../components/MuiDatagrid";
import {UnitMapper, UnitOrder} from "../../../utils/globalFunction";
import Grid from "@mui/material/Grid";
import moment from "moment";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import {Collapse} from "@mui/material";
const OwnerCargoOperationDetail = ({info = {},loading}) => {
    const [isOpen,setIsOpen] = useState(true)
    const [row,setRow] = useState([])
    const {t} = useTranslation()

    useEffect(()=>{
        setRow([...[],{...info,id:1}])
    },[info])

    return(<React.Fragment>
            <Fade in = {true}>
                <Card sx={{minWidth: 350}}>
                    <MDBox
                        mx={1}
                        mt={-3}
                        py={1}
                        px={2}
                        variant="gradient"
                        bgColor="light"
                        borderRadius="lg"
                        coloredShadow="light"
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'space-between'}

                    >
                        <MDTypography variant="h6" >
                            {t('Operation Records')}
                        </MDTypography>
                        <IconButton size={'small'}  disabled={loading}  onClick={()=>setIsOpen(!isOpen)}>
                            {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                        </IconButton>
                    </MDBox>
                    <Collapse in={isOpen&& !loading} timeout={500}>
                        <MDBox pt={1} pb={2} px={2}>
                            <Grid container xs={12} display="flex" p={0} m={0}>
                                <Grid item mb={1} xs={12} md={6} lg={3}>
                                    <MDBox>
                                        <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                             {t('Creator')}:
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox>
                                        <MDTypography variant="button" color="text" fontWeight="regular">
                                            {info?.addWho}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                                <Grid item mb={1} xs={12} md={6} lg={3}>
                                    <MDBox>
                                        <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                            {t('Time Created')}:
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox>
                                        <MDTypography variant="button" color="text" fontWeight="regular">
                                            {info?.addTime?moment(info?.addTime).format('YYYY-MM-DD'):''}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>
                                <Grid item mb={1} xs={12} md={6} lg={3}>
                                    <MDBox>
                                        <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                            {t('Latest Editor')}:
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox>
                                        <MDTypography variant="button" color="text" fontWeight="regular">
                                            {info?.editWho}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>


                                <Grid item mb={1} xs={12} md={6} lg={3}>
                                    <MDBox>
                                        <MDTypography variant="button" fontWeight="medium" gutterBottom >
                                            {t('Latest Edited')}:
                                        </MDTypography>
                                    </MDBox>
                                    <MDBox>
                                        <MDTypography variant="button" color="text" fontWeight="regular">
                                            {info?.editTime?moment(info?.editTime).format('YYYY-MM-DD'):''}
                                        </MDTypography>
                                    </MDBox>
                                </Grid>




                            </Grid>
                        </MDBox>
                    </Collapse>
                </Card>
            </Fade>

        </React.Fragment>
    )
}

export default OwnerCargoOperationDetail